<div class = "container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class = "card-form" [formGroup]="motorForm" (ngSubmit)="submitForm()" novalidate>
    <div class="blue-top" style="display: flex; align-items: center; box-sizing: border-box; padding: 24px; padding-top: 24px;">
      <h2 style="color: white!important; font-weight: 500; margin-bottom: 0px !important;" > {{claim.replace('_', ' ') + ' claim details'}} </h2>
    </div>
    <!-- MANDATORY SECTION -->
    <div class="card-section top-section">
        <h2>Please provide more details of the incident</h2>
        <!-- LOCATION -->
        <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 16px;">
            <mat-label class="form-select-placeholder-unselected" >
                Location of the incident
            </mat-label>
            <mat-hint>Enter location</mat-hint>
            <input matInput formControlName="location" (blur)="logErrors()">
            <mat-error *ngIf="formErrors['location']">{{formErrors['location']}}</mat-error>
        </mat-form-field>
        <!-- DATE -->
        <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 16px;">
            <mat-label class="form-select-placeholder-unselected" >
                Date of loss
            </mat-label>
            <mat-hint>Enter date</mat-hint>
            <input matInput formControlName="date"
                [min]="minDate"
                [max]="maxDate"
                [matDatepicker]="picker"
                readonly="true"
                (click)="picker.open()" (dateChange)="onDateChange()" (blur)="logErrors()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker > </mat-datepicker>
            <mat-error *ngIf="formErrors['date']">{{formErrors['date']}}</mat-error>
        </mat-form-field>
        <!-- TIME -->
        <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 32px;">
            <mat-label class="form-select-placeholder-unselected" >
                Time of loss
            </mat-label>
            <mat-hint>time</mat-hint>
            <input matInput type="time" formControlName="time" (blur)="logErrors()">
            <mat-error *ngIf="formErrors['time']">{{formErrors['time']}}</mat-error>
        </mat-form-field>
        <!-- DESCRIPTION -->
        <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
            <mat-label class="form-select-placeholder-unselected" >
                Brief decription of the loss and details of the incident
            </mat-label>
            <textarea matInput formControlName="description"
                placeholder="How did the incident happen?"
                (blur)="logErrors()"
                style="height: 70px;">
            </textarea>
            <mat-error *ngIf="formErrors['description']">
                {{formErrors['description']}}
            </mat-error>
        </mat-form-field>
    </div>

    <!-- ACTION BUTTONS -->
    <div class="card-section bottom-section" >
        <div class="row-div">
            <button mat-stroked-button type="button" (click)="confirmCancel()">
                <span class="button-text">Cancel</span>
            </button>
            <button mat-button type="submit" [disabled]="!motorForm.valid">
                <span class="button-text">Save and Continue</span>
            </button>
        </div>
    </div>
  </form>
</div>
